import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { CurrentUserService } from '../../user/services/current-user.service';
import { AuthService } from '../services/auth.service';
import { checkIsLoggedIn, loadPermissions } from '../store/auth/auth.actions';

export const authGuard = () => {
  const store = inject<Store>(Store);
  const authService = inject(AuthService);
  const router = inject(Router);
  const currentUser = inject(CurrentUserService);

  const isLoggedIn = authService.isLoggedIn();
  store.dispatch(checkIsLoggedIn({ isLoggedIn: isLoggedIn }));

  if (isLoggedIn) {
    store.dispatch(loadPermissions({ user: currentUser.user }));
    return true;
  }
  const returnUrl = window.location.pathname + window.location.search;
  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl },
  });
};
